var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgServersideIconCheckboxBlack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "16.87 16.9 16.23 16.23",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HILFSLINIEN"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_UMGEWANDELT"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#525861",
    d: "M30.5,16.875h-11c-1.447,0-2.625,1.178-2.625,2.625v11c0,1.447,1.178,2.625,2.625,2.625h11 c1.447,0,2.625-1.178,2.625-2.625v-11C33.125,18.053,31.947,16.875,30.5,16.875z M31.875,30.5c0,0.758-0.617,1.375-1.375,1.375h-11 c-0.758,0-1.375-0.617-1.375-1.375v-11c0-0.758,0.617-1.375,1.375-1.375h11c0.758,0,1.375,0.617,1.375,1.375V30.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_PFADE",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "none",
    stroke: "#363A40",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M30.5,32.5h-11c-1.105,0-2-0.895-2-2v-11c0-1.105,0.895-2,2-2h11c1.105,0,2,0.895,2,2v11C32.5,31.605,31.605,32.5,30.5,32.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "BESCHRIFTUNG"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgServersideIconCheckboxBlack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/serverside-icon-checkbox-black.40dd15c1.svg";
export { ForwardRef as ReactComponent };